import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Platform } from '@ionic/angular';
import { Keyboard, KeyboardInfo, KeyboardResize } from '@capacitor/keyboard';
import { FeedbackService, VibrateType } from 'src/app/_provider/feedback.service';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import dayjs from '../../../../_utils/dayjs.config';
import { SaveService } from 'src/app/_provider/save.service';

export interface TargetTimeAmount{
  days: number
  hours: number
  minutes: number
  seconds: number
}

@Component({
  selector: 'app-time-amount-select',
  templateUrl: './time-amount-select.component.html',
  styleUrls: ['./time-amount-select.component.scss'],
})
export class TimeAmountSelectComponent implements OnInit, OnDestroy {

  public amount: TargetTimeAmount = {days: 0, hours: 0, minutes: 0, seconds: 0}

  public modalRef: HTMLIonModalElement
  public initialBreakpoint: number

  private isKeyboardOpen: boolean = false
  private closed: boolean = false

  public formGroup: UntypedFormGroup
  constructor(
    public platform: Platform,
    private feedback: FeedbackService,
    private ticketSrv: TicketEmployee.TicketService,
    private saveSrv: SaveService.Ticket
  ) {  

    const days: number = this.ticketSrv.targetTime  / 60 / 60 / 24 
    var time: dayjs.Dayjs = dayjs.utc(this.ticketSrv.targetTime * 1000)
    this.amount = {
      days: days > 0 ? Math.floor(days) : 0,
      hours: time.get("hours") ,
      minutes: time.get("minutes"),
      seconds: time.get("seconds"),
    }
  }
  async ngOnDestroy() {
    if(this.platform.is("capacitor")){
      await Keyboard.setResizeMode({mode: KeyboardResize.Ionic})
      await Keyboard.removeAllListeners()
    }
  }

  async ngOnInit() {
    if(this.platform.is("capacitor")){
      // this.modalRef.breakpoints.push(Keyboard.)
      await Keyboard.setResizeMode({mode: KeyboardResize.None})
      Keyboard.addListener("keyboardWillShow", (info: KeyboardInfo)=>{
        this.isKeyboardOpen = true
        const breakpoint: number = Math.floor(100/window.innerHeight * (260 + info.keyboardHeight)) / 100
        this.modalRef.breakpoints.push(breakpoint)
        this.modalRef.setCurrentBreakpoint(breakpoint)
      })
      Keyboard.addListener("keyboardWillHide", async()=>{
        this.isKeyboardOpen = false
        if(this.closed) return
        await this.modalRef.setCurrentBreakpoint(this.initialBreakpoint)
        this.modalRef.breakpoints.filter(number => number !== Math.max(...this.modalRef.breakpoints))
      }) 
    }
    this.modalRef.onWillDismiss().then(async ()=>{
      this.closed = true
      this.ticketSrv.targetTime = this.amount.seconds + +(this.amount.minutes * 60) + +(this.amount.hours * 60 * 60) + +(this.amount.days * 24 * 60 * 60)
      await this.saveSrv.saveTargettime(this.ticketSrv.targetTime)
    })
  }

  public up(name: string){
    this.feedback.vibrate(VibrateType.light)
    if(this.amount[name] >= 9999) return
    this.amount[name]++
  }

  public down(name: string){
    this.feedback.vibrate(VibrateType.light)
    if(this.amount[name]  <= 0) return
    this.amount[name]--
  }

  public async toggleModalBreakpoint(ref: any){
    if(this.platform.is("capacitor")){
      if(this.isKeyboardOpen)  ref.select()
      else setTimeout(() => ref.select(), 500); 
    }else{
      ref.select()
    }
  } 



}


